<template>
  <div class="specs" :class="{ disabled }">
    <MultipleSpecs
      v-bind="$props"
      @change="onMultipleSpecsChange"
    ></MultipleSpecs>
  </div>
</template>
<style lang="stylus" scoped>
.specs
  position relative
  width 100%

  &.disabled::before
    content ''
    position absolute
    top 0
    left 0
    width 100%
    height 100%
    background rgba(#ddd, 0.5)
    z-index 5
    cursor not-allowed
</style>
<script>
import MultipleSpecs from './MultipleSpecs'
export default {
  components: {
    MultipleSpecs,
  },
  props: [
    'value',
    'options',
    'max',
    'skus',
    'extraSpecs',
    'disabled',
  ],
  methods: {
    onMultipleSpecsChange(payload) {
      if (payload.prop === 'value') {
        this.$emit('input', payload.value)
      } else {
        this.$emit(`update:${payload.prop}`, payload.value)
      }
    },
  },
}
</script>
